import React from "react";
import {
  LocalizationProvider,
  DatePicker as MuiDatePicker,
} from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import moment from "moment";
import { TextField } from "@mui/material";

const DatePicker = ({
  onChange,
  value,
  format = "DD-MM-YYYY",
  inputSx = {},
}) => {
  const handleDateChange = (date) => {
    const formatted = date ? moment(date).format(format) : "";
    onChange(formatted);
  };

  return (
    <LocalizationProvider dateAdapter={AdapterMoment} key="dob-picker">
      <MuiDatePicker
        inputFormat={format}
        value={value ? moment(value, format) : null}
        onChange={handleDateChange}
        renderInput={(params) => (
          <TextField
            {...params}
            fullWidth
            name="dateOfBirth"
            sx={inputSx}
            inputProps={{
              ...params.inputProps,
              autocomplete: "off",
            }}
          />
        )}
        disableFuture
      />
    </LocalizationProvider>
  );
};

export default DatePicker;
